import type { ComponentSchema } from "../../../../../schema-types"
import { primaryButtonFields, outlineButtonFields } from "./button-schema-fields"

export const schema: ComponentSchema = {
  type: 'similar-products',
  label: 'Similar Products',
  description: 'A section that displays products similar to a given product.',
  supportedPages: ['shop', 'product'],
  variants: [
    {
      id: 'v1',
      label: 'Default (Grid)',
      fields: [
        { key: 'title', label: 'Section Title', type: 'string', default: 'Similar Products' },
        { key: 'limit', label: 'Limit', type: 'number', default: 4 },
      ],
    },
  ],
  commonFields: [
    {
      key: 'productCardVariant',
      label: 'Product Card Style',
      type: 'select',
      options: [
        { label: 'Standard (V1)', value: 'v1' },
        { label: 'Clean (V2)', value: 'v2' },
      ],
      default: 'v1',
    },

    // ─── Product Card Buttons ─────────────────────────────────────────
    ...primaryButtonFields('buttons.orderNow', 'Order Now Button'),
    ...outlineButtonFields('buttons.addToCart', 'Add to Cart Button'),
  ],
}
